import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IdentificationSearchResult} from "../../../record/identification-models";
import {IdWithIndex} from "../heraeus.module";
import {isValidMatchOutcome, MATCH_OUTCOME} from "../../../../constants/match-outcome.enum";

@Component({
  selector: 'heraeus-identification-list',
  templateUrl: './heraeus-identifications-list-view.component.html',
  styleUrls: ['./heraeus-identifications-list-view.component.scss']
})
export class HeraeusIdentificationsListViewComponent {

  @Input() identificationResults: IdentificationSearchResult[] = [];
  @Input() currentIdentificationId: string | null = null;
  @Input() dataset: string | null = null;
  @Input() isSuperuser: boolean = false;

  @Output() setIdentificationEvent: EventEmitter<IdWithIndex> = new EventEmitter<IdWithIndex>();

  protected readonly matchOutcome = MATCH_OUTCOME;
  protected readonly isValidMatchOutcome = isValidMatchOutcome;
}
